export default __webpack_public_path__ + "static/carousel-homepage-2-235c94e52f4bca9c9ba1a48a8d3b5c9b.jpg";